export function downloadFileFromBlob({
  blob,
  fileName
}: {
  blob: Blob
  fileName: string
}) {
  const blobURL = window.URL.createObjectURL(blob)
  const tempLink = document.createElement('a')
  tempLink.href = blobURL
  tempLink.setAttribute('download', fileName)
  tempLink.click()
  tempLink.remove()
}

export function downloadFileFromUrl({
  url,
  fileName
}: {
  url: string
  fileName: string
}) {
  const tempLink = document.createElement('a')
  tempLink.href = url
  tempLink.setAttribute('download', fileName)
  tempLink.click()
  tempLink.remove()
}
